
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kiosks/[cName]",
      function () {
        return require("private-next-pages/kiosks/[cName].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kiosks/[cName]"])
      });
    }
  